import { render, staticRenderFns } from "./GapStatisticEvidence.vue?vue&type=template&id=30cdfb28&scoped=true&"
import script from "./GapStatisticEvidence.vue?vue&type=script&lang=ts&"
export * from "./GapStatisticEvidence.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30cdfb28",
  null
  
)

export default component.exports